module.exports = __webpack_public_path__ + "img/111052.94dcd243.png";